import { render, staticRenderFns } from "./AdId.vue?vue&type=template&id=079ef9a7&scoped=true"
import script from "./AdId.vue?vue&type=script&lang=js"
export * from "./AdId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079ef9a7",
  null
  
)

export default component.exports